import { createComment } from 'graphql/customQueries';
import { CustomCreateCommentMutation } from 'API';
import { client } from 'lib/graphql-client';
import { GraphQLResult } from '@aws-amplify/api';

class CommentService {
  create = async (
    authorID: string, comment: string, sourceID: string,
  ) => client.graphql({
    query: createComment,
    variables: {
      input: {
        authorID,
        authorEmployerID: authorID,
        authorForeignNationalID: authorID,
        authorTeamMemberID: authorID,
        note: comment,
        sourceID,
      },
    },
  }) as unknown as GraphQLResult<CustomCreateCommentMutation>;
}

export default new CommentService();
